import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Container,
  Row,
  Col,
  Form,
  Input,
  FormFeedback,
} from "reactstrap";
import CustomInput from "../../Common/CustomInput/CustomInput";
import CustomSelect from "../../Common/CustomSelect/CustomSelect";
import axios from "axios";
import toast from "react-hot-toast";
import AuthServices from "../../../services/AuthServices/AuthServices";
import CoopUserService from "../../../services/CoopUserService/CoopUserService";
import AddUserValidation from "../Validation/AddUserValidation";

const AddUserModal = ({
  isOpen,
  toggle,
  fetchUserType,
  selectedUser,
  setSelectedUser,
}) => {
  const [profileImage, setProfileImage] = useState("/imagePlaceholder.png"); // Default image placeholder
  const token = JSON.parse(localStorage.getItem("user")).accessToken;
  const [roleOptions, setRoleOptions] = useState([]);
  const [formattedImage, setFormattedImage] = useState(null);
  const [getUser, setGetUser] = useState(null);
  const [newPasswordShow, setNewPasswordShow] = useState(false);
  const [confirmPasswordShow, setConfirmPasswordShow] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      Username: selectedUser?.userName || "",
      FirstName: selectedUser?.firstName || "",
      LastName: selectedUser?.lastName || "",
      Image: selectedUser?.image ?? "",
      Address: selectedUser?.address || "",
      EmailAddress: selectedUser?.email || "",
      roles:
        selectedUser?.roles?.map((role) => ({
          label: role.name,
          value: role.id,
        })) || [],
      PhoneNumber: selectedUser?.phone || "",
      Password: selectedUser?.password || "",
      ConfirmPassword: selectedUser?.confirmPassword || "",
    },
    validationSchema: AddUserValidation,
    onSubmit: async (values, { resetForm }) => {
      const formData = new FormData();
      for (const [key, value] of Object.entries(values)) {
        if (key !== "Image" && key !== "roles") {
          formData.append(key, value);
        }
      }

      // Handle the image file if it exists
      if (values.Image && values.Image instanceof File) {
        formData.append("Image", values.Image);
      } else {
        // Check if the image is a Base64 string or a binary string
        const imageString = values.Image;
        let binaryString;

        const isBase64 = (str) => {
          try {
            return btoa(atob(str)) === str;
          } catch (err) {
            return false;
          }
        };

        if (isBase64(imageString.split(",")[1] || imageString)) {
          let base64String = imageString;
          let base64;

          if (base64String.includes(",")) {
            base64 = base64String.split(",")[1];
          } else {
            base64 = base64String;
          }

          binaryString = atob(base64);
        } else {
          binaryString = imageString;
        }

        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }

        const blob = new Blob([bytes], { type: "image/jpeg" }); // change the type according to your image type
        formData.append("Image", blob, "image.jpg"); // 'image.jpg' can be any name you want for the file
      }

      console.log("values.roles", values.roles);
      values.roles.forEach((role) => {
        formData.append("roles", role.label);
      });

      // try {
      //   if (selectedUser) {
      //     await axios.put(
      //       `http://api.dsccou.sebs.asia/api/coopuser/${selectedUser.id}`,
      //       formData,
      //       {
      //         headers: {
      //           "Content-Type": "multipart/form-data",
      //           Authorization: `Bearer ${token}`,
      //         },
      //       }
      //     );
      //     toast.success("User Updated Successfully");
      //     toggle();
      //     resetForm();
      //     setSelectedUser(null);
      //     fetchUserType();
      //   } else {
      //     await axios.post(
      //       `http://api.dsccou.sebs.asia/api/coopuser/register-coopuser`,
      //       formData,
      //       {
      //         headers: {
      //           "Content-Type": "multipart/form-data",
      //           Authorization: `Bearer ${token}`,
      //         },
      //       }
      //     );
      //     toast.success("User Added Successfully");
      //     toggle();
      //     resetForm();
      //     setSelectedUser(null);
      //     fetchUserType();
      //   }
      // } catch (error) {
      //   toast.error(error?.response?.message || "An error occurred");
      //   console.log("error", error?.response?.message);
      // }
      try {
        if (selectedUser) {
          await axios.put(
            `http://api.dsccou.sebs.asia/api/coopuser/${selectedUser.id}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          toast.success("User Updated Successfully");
          toggle();
          resetForm();
          setSelectedUser(null);
          fetchUserType();
        } else {
          await axios.post(
            "http://api.dsccou.sebs.asia/api/coopuser/register-coopuser",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          toast.success("User Added Successfully");
          toggle();
          resetForm();
          setSelectedUser(null);
          fetchUserType();
        }
      } catch (error) {
        // Log the entire error object for debugging
        console.log("Full error object:", error);

        // Extract and handle the error message
        const errorMessage =
          error.response?.data?.message || // API error message
          error.response?.data?.error || // Alternative error message
          error.message || // Network or other errors
          "An error occurred"; // Fallback message

        // Display the error message in a toast notification
        toast.error(errorMessage);
      }
    },
  });

  {
    // const formik = useFormik({
    //   enableReinitialize: true,
    //   initialValues: {
    //     Username: selectedUser?.userName || "",
    //     FirstName: selectedUser?.firstName || "",
    //     LastName: selectedUser?.lastName || "",
    //     Image: selectedUser?.image ?? "",
    //     Address: selectedUser?.address || "",
    //     EmailAddress: selectedUser?.email || "",
    //     roles:
    //       selectedUser?.roles && selectedUser.roles.length > 0
    //         ? {
    //             label: selectedUser.roles[0].name,
    //             value: selectedUser.roles[0].id,
    //           }
    //         : [],
    //     PhoneNumber: selectedUser?.phone || "",
    //     Password: selectedUser?.password || "",
    //     ConfirmPassword: selectedUser?.confirmPassword || "",
    //   },
    //   validationSchema: AddUserValidation,
    //   onSubmit: async (values, { resetForm }) => {
    //     const formData = new FormData();
    //     for (const [key, value] of Object.entries(values)) {
    //       if (key !== "Image" && key !== "roles") {
    //         formData.append(key, value);
    //       }
    //     }
    //     // Handle the image file if it exists
    //     if (values.Image && values.Image instanceof File) {
    //       formData.append("Image", values.Image);
    //     } else {
    //       // Check if the image is a Base64 string or a binary string
    //       const imageString = values.Image;
    //       let binaryString;
    //       const isBase64 = (str) => {
    //         try {
    //           return btoa(atob(str)) === str;
    //         } catch (err) {
    //           return false;
    //         }
    //       };
    //       if (isBase64(imageString.split(",")[1] || imageString)) {
    //         let base64String = imageString;
    //         let base64;
    //         if (base64String.includes(",")) {
    //           base64 = base64String.split(",")[1];
    //         } else {
    //           base64 = base64String;
    //         }
    //         binaryString = atob(base64);
    //       } else {
    //         binaryString = imageString;
    //       }
    //       const len = binaryString.length;
    //       const bytes = new Uint8Array(len);
    //       for (let i = 0; i < len; i++) {
    //         bytes[i] = binaryString.charCodeAt(i);
    //       }
    //       const blob = new Blob([bytes], { type: "image/jpeg" }); // change the type according to your image type
    //       formData.append("Image", blob, "image.jpg"); // 'image.jpg' can be any name you want for the file
    //     }
    //     console.log("values.roles", values.roles);
    //     values.roles.forEach((role) => {
    //       formData.append("roles", role.label);
    //     });
    //     try {
    //       if (selectedUser) {
    //         await axios.put(
    //           `http://api.dsccou.sebs.asia/api/coopuser/${selectedUser.id}`,
    //           formData,
    //           {
    //             headers: {
    //               "Content-Type": "multipart/form-data",
    //               Authorization: `Bearer ${token}`,
    //             },
    //           }
    //         );
    //         toast.success("User Updated Successfully");
    //         toggle();
    //         resetForm();
    //         setSelectedUser(null);
    //         fetchUserType();
    //       } else {
    //         await axios.post(
    //           `http://api.dsccou.sebs.asia/api/coopuser/register-coopuser`,
    //           formData,
    //           {
    //             headers: {
    //               "Content-Type": "multipart/form-data",
    //               Authorization: `Bearer ${token}`,
    //             },
    //           }
    //         );
    //         toast.success("User Added Successfully");
    //       }
    //       toggle();
    //       resetForm();
    //       setSelectedUser(null);
    //       fetchUserType();
    //     } catch (error) {
    //       toast.error(error.response?.data || "An error occurred");
    //       console.log("error", error);
    //     }
    //   },
    // });
  }
  const fetchRoles = async () => {
    try {
      const response = await AuthServices.getRoles();
      const temp = response.map((item) => ({
        label: item.name,
        value: item.id,
      }));
      setRoleOptions(temp);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  const handleCancel = () => {
    toggle();
    setSelectedUser(null);
    setProfileImage("/imagePlaceholder.png");
    formik.resetForm();
  };

  const handleUserProfileImageClick = () => {
    document.getElementById("profile-img-file-input").click();
  };
  useEffect(() => {
    (async () => {
      if (selectedUser) {
        try {
          const response = await CoopUserService.getById(selectedUser.id);
          if (response.image) {
            setProfileImage(`data:image/png;base64,${response.image}`);
            const base64 = response.image.split(",")[1] || response.image;
            const sanitizedBase64 = base64.replace(/[^A-Za-z0-9+/=]/g, "");
            const binaryString = atob(sanitizedBase64);
            setFormattedImage(binaryString);
          }
        } catch (error) {
          console.log("🚀 ~ async ~ error:", error);
        }
      }
    })();
  }, [selectedUser]);

  // useEffect(() => {
  //   (async () => {
  //     if (selectedUser) {
  //       try {
  //         const response = await CoopUserService.getById(selectedUser.id);
  //         // console.log("🚀 ~ async ~ response", response);
  //         setGetUser(response);
  //         if (response.image) {
  //           setProfileImage(`data:image/png;base64,${selectedUser.image}`);
  //           const base64 = selectedUser.image.split(",")[1];
  //           const binaryString = atob(base64);
  //           setFormattedImage(binaryString);
  //         }
  //       } catch (error) {
  //         console.log("🚀 ~ async ~ error:", error);
  //       }
  //     }
  //   })();
  // }, [selectedUser]);

  // console.log("Get User role", getUser);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    formik.setFieldValue("Image", file);

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfileImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    if (!isOpen) {
      formik.resetForm();
      setSelectedUser(null);
      setProfileImage("/imagePlaceholder.png");
    }
  }, [isOpen]);

  return (
    <Modal className="w-100" isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        {selectedUser ? "Edit User" : "Add New User"}
      </ModalHeader>
      <Form onSubmit={formik.handleSubmit}>
        <ModalBody>
          <Container>
            <FormGroup>
              <CustomInput
                required
                label="Username"
                type="text"
                name="Username"
                id="Username"
                handleBlur={formik.handleBlur}
                error={formik.errors.Username}
                handleChange={formik.handleChange}
                value={formik.values.Username}
                touched={formik.touched.Username}
              />
            </FormGroup>
            <Row>
              <Col xs={6}>
                <CustomInput
                  required
                  label="First Name"
                  type="text"
                  name="FirstName"
                  id="FirstName"
                  placeholder={"First Name"}
                  handleBlur={formik.handleBlur}
                  error={formik.errors.FirstName}
                  handleChange={formik.handleChange}
                  value={formik.values.FirstName}
                  touched={formik.touched.FirstName}
                />
              </Col>
              <Col xs={6}>
                <CustomInput
                  required
                  label="Last Name"
                  type="text"
                  name="LastName"
                  id="LastName"
                  placeholder={"Last Name"}
                  handleBlur={formik.handleBlur}
                  error={formik.errors.LastName}
                  handleChange={formik.handleChange}
                  value={formik.values.LastName}
                  touched={formik.touched.LastName}
                />
              </Col>
            </Row>
            <FormGroup>
              <CustomInput
                required
                label="PhoneNumber"
                name="PhoneNumber"
                id="PhoneNumber"
                error={formik.errors.PhoneNumber}
                handleBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                value={formik.values.PhoneNumber}
                touched={formik.touched.PhoneNumber}
              />
            </FormGroup>
            <FormGroup>
              <CustomInput
                required
                label="Address"
                name="Address"
                id="Address"
                error={formik.errors.Address}
                handleBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                value={formik.values.Address}
                touched={formik.touched.Address}
              />
            </FormGroup>
            <FormGroup>
              <CustomInput
                required
                label="Email Address"
                name="EmailAddress"
                id="EmailAddress"
                error={formik.errors.EmailAddress}
                handleBlur={formik.handleBlur}
                handleChange={formik.handleChange}
                value={formik.values.EmailAddress}
                touched={formik.touched.EmailAddress}
              />
            </FormGroup>
            <FormGroup>
              <Row>
                <Col xs={6}>
                  <CustomSelect
                    required
                    isMulti
                    label="Roles"
                    name="roles"
                    id="roles"
                    handleChange={(value) =>
                      formik.setFieldValue("roles", value)
                    }
                    options={roleOptions}
                    placeholder={"Select Roles"}
                    value={formik.values.roles}
                    errors={formik.errors.roles}
                    touched={formik.touched.roles}
                    setFieldTouched={formik.setFieldTouched}
                    setFieldValue={formik.setFieldValue}
                    handleBlur={formik.handleBlur}
                  />
                </Col>
              </Row>
            </FormGroup>
            <Row>
              <Col xs={6}>
                <FormGroup>
                  <Label className="form-label">
                    Password <sup className="text-danger">*</sup>
                  </Label>
                  <div className="position-relative auth-pass-inputgroup mb-3">
                    <Input
                      // required
                      id="Password"
                      name="Password"
                      value={formik.values.Password}
                      type={newPasswordShow ? "text" : "password"}
                      className="form-control pe-5"
                      placeholder={"Enter password"}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      invalid={
                        formik.touched.Password && formik.errors.Password
                          ? true
                          : false
                      }
                      // error={formik.errors.Password}
                      // handleBlur={formik.handleBlur}
                      // handleChange={formik.handleChange}
                      // touched={formik.touched.Password}
                      // label="Password"
                    />
                    {formik.touched.Password && formik.errors.Password ? (
                      <FormFeedback type="invalid">
                        {formik.errors.Password}
                      </FormFeedback>
                    ) : null}
                    <button
                      className="btn btn-link position-absolute top-0 end-0 text-decoration-none text-muted"
                      type="button"
                      id="password-addon"
                      onClick={() => setNewPasswordShow(!newPasswordShow)}
                    >
                      <i className="ri-eye-fill align-middle"></i>
                    </button>
                  </div>
                </FormGroup>
              </Col>
              <Col xs={6}>
                <FormGroup>
                  <Label className="form-label">
                    Confirm Password <sup className="text-danger">*</sup>
                  </Label>
                  <div className="position-relative auth-pass-inputgroup mb-3">
                    <Input
                      // required
                      id="ConfirmPassword"
                      name="ConfirmPassword"
                      value={formik.values.ConfirmPassword}
                      type={confirmPasswordShow ? "text" : "password"}
                      className="form-control pe-5"
                      placeholder="Enter password again"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      invalid={
                        formik.touched.ConfirmPassword &&
                        formik.errors.ConfirmPassword
                          ? true
                          : false
                      }
                      // label="Confirm Password"
                      // handleBlur={formik.handleBlur}
                      // handleChange={formik.handleChange}
                      // error={formik.errors.ConfirmPassword}
                      // touched={formik.touched.ConfirmPassword}
                    />
                    {formik.touched.ConfirmPassword &&
                    formik.errors.ConfirmPassword ? (
                      <FormFeedback type="invalid">
                        {formik.errors.ConfirmPassword}
                      </FormFeedback>
                    ) : null}
                    <button
                      className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                      type="button"
                      id="password-addon"
                      onClick={() =>
                        setConfirmPasswordShow(!confirmPasswordShow)
                      }
                    >
                      <i className="ri-eye-fill align-middle"></i>
                    </button>
                  </div>
                </FormGroup>
              </Col>
            </Row>
            <FormGroup>
              <div className="text-center">
                <div
                  className="profile-user position-relative d-inline-block mx-auto mb-4"
                  onClick={handleUserProfileImageClick}
                >
                  <img
                    src={profileImage}
                    className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                    alt="user-profile"
                  />
                  <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
                    <input
                      id="profile-img-file-input"
                      type="file"
                      className="profile-img-file-input"
                      onChange={handleImageChange}
                      accept="image/*"
                      style={{ display: "none" }}
                    />
                    <Label
                      htmlFor="profile-img-file-input"
                      className="profile-photo-edit avatar-xs"
                    >
                      <span className="avatar-title rounded-circle bg-light text-body">
                        <i
                          className="ri-camera-fill"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleUserProfileImageClick();
                          }}
                        ></i>
                      </span>
                    </Label>
                  </div>
                </div>
              </div>
            </FormGroup>
          </Container>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" type="submit">
            {selectedUser ? "Save" : "Add"}
          </Button>
          <Button color="danger" onClick={handleCancel}>
            Cancel
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default AddUserModal;
// import React, { useState, useEffect } from "react";
// import { useFormik } from "formik";
// import {
//   Button,
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   FormGroup,
//   Label,
//   Container,
//   Row,
//   Col,
//   Form,
// } from "reactstrap";
// import CustomInput from "../../Common/CustomInput/CustomInput";
// import CustomSelect from "../../Common/CustomSelect/CustomSelect";
// import axios from "axios";
// import toast from "react-hot-toast";
// import AuthServices from "../../../services/AuthServices/AuthServices";
// import CoopUserService from "../../../services/CoopUserService/CoopUserService";
// import AddUserValidation from "../Validation/AddUserValidation";

// const AddUserModal = ({
//   isOpen,
//   toggle,
//   fetchUserType,
//   selectedUser,
//   setSelectedUser,
// }) => {
//   const [profileImage, setProfileImage] = useState("/imagePlaceholder.png"); // Default image placeholder
//   const token = JSON.parse(localStorage.getItem("user")).accessToken;
//   const [roleOptions, setRoleOptions] = useState([]);
//   const [formattedImage, setFormattedImage] = useState(null);

//   console.log("Selected User's Rolee:::", selectedUser?.roles);
//   const formik = useFormik({
//     enableReinitialize: true,
//     initialValues: {
//       Username: selectedUser?.userName || "",
//       FirstName: selectedUser?.firstName || "",
//       LastName: selectedUser?.lastName || "",
//       Image: selectedUser?.image ?? "",
//       Address: selectedUser?.address || "",
//       EmailAddress: selectedUser?.email || "",
//       roles:
//         selectedUser?.roles && selectedUser.roles.length > 0
//           ? selectedUser.roles.map((role) => ({
//               label: role[0].name,
//               value: role[0].id,
//             }))
//           : [{ label: "N/A", value: "" }],
//       // {selectedUser.roles && selectedUser.roles.length > 0
//       //   ? data.roles[0].name
//       //   : "N/A"}{" "}
//       PhoneNumber: selectedUser?.phone || "",
//       Password: selectedUser?.password || "",
//       ConfirmPassword: selectedUser?.confirmPassword || "",
//     },

//     // validationSchema: AddUserValidation,
//     onSubmit: async (values, { resetForm }) => {
//       const formData = new FormData();
//       for (const [key, value] of Object.entries(values)) {
//         if (key !== "Image" && key !== "roles") {
//           formData.append(key, value);
//         }
//       }

//       // Handle the image file if it exists
//       if (values.Image && values.Image instanceof File) {
//         formData.append("Image", values.Image);
//       } else {
//         // Check if the image is a Base64 string or a binary string
//         const imageString = values.Image;
//         let binaryString;

//         const isBase64 = (str) => {
//           try {
//             return btoa(atob(str)) === str;
//           } catch (err) {
//             return false;
//           }
//         };

//         if (isBase64(imageString.split(",")[1] || imageString)) {
//           let base64String = imageString;
//           let base64;

//           if (base64String.includes(",")) {
//             base64 = base64String.split(",")[1];
//           } else {
//             base64 = base64String;
//           }

//           binaryString = atob(base64);
//         } else {
//           binaryString = imageString;
//         }

//         const len = binaryString.length;
//         const bytes = new Uint8Array(len);
//         for (let i = 0; i < len; i++) {
//           bytes[i] = binaryString.charCodeAt(i);
//         }

//         const blob = new Blob([bytes], { type: "image/jpeg" }); // change the type according to your image type
//         formData.append("Image", blob, "image.jpg"); // 'image.jpg' can be any name you want for the file
//       }

//       values.roles.forEach((role) => {
//         formData.append("roles", role.label);
//       });
//       try {
//         if (selectedUser) {
//           await axios.put(
//             `http://api.dsccou.sebs.asia/api/coopuser/${selectedUser.id}`,
//             formData,
//             {
//               headers: {
//                 "Content-Type": "multipart/form-data",
//                 Authorization: `Bearer ${token}`,
//               },
//             }
//           );
//           toast.success("User Updated Successfully");
//           toggle();
//           resetForm();
//           setSelectedUser(null);
//           fetchUserType();
//         } else {
//           await axios.post(
//             `http://api.dsccou.sebs.asia/api/coopuser/register-coopuser`,
//             formData,
//             {
//               headers: {
//                 "Content-Type": "multipart/form-data",
//                 Authorization: `Bearer ${token}`,
//               },
//             }
//           );
//           toast.success("User Added Successfully");
//         }
//         toggle();
//         resetForm();
//         setSelectedUser(null);
//         fetchUserType();
//       } catch (error) {
//         toast.error(error.response?.data || "An error occurred");
//       }
//     },
//   });

//   const fetchRoles = async () => {
//     try {
//       const response = await AuthServices.getRoles();
//       const temp = response.map((item) => ({
//         label: item.name,
//         value: item.id,
//       }));
//       setRoleOptions(temp);
//     } catch (error) {
//       console.log("error", error);
//     }
//   };

//   useEffect(() => {
//     fetchRoles();
//   }, []);

//   const handleCancel = () => {
//     toggle();
//     setSelectedUser(null);
//     setProfileImage("/imagePlaceholder.png");
//     formik.resetForm();
//   };

//   const handleUserProfileImageClick = () => {
//     document.getElementById("profile-img-file-input").click();
//   };

//   useEffect(() => {
//     (async () => {
//       if (selectedUser) {
//         try {
//           const response = await CoopUserService.getById(selectedUser.id);
//           if (response.image) {
//             setProfileImage(`data:image/png;base64,${selectedUser.image}`);
//             const base64 = selectedUser.image.split(",")[1];
//             const binaryString = atob(base64);
//             setFormattedImage(binaryString);
//           }
//         } catch (error) {
//           console.log("🚀 ~ async ~ error:", error);
//         }
//       }
//     })();
//   }, [selectedUser]);

//   const handleImageChange = (event) => {
//     const file = event.target.files[0];
//     formik.setFieldValue("Image", file);

//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setProfileImage(reader.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   useEffect(() => {
//     if (!isOpen) {
//       formik.resetForm();
//       setSelectedUser(null);
//       setProfileImage("/imagePlaceholder.png");
//     }
//   }, [isOpen]);

//   return (
//     <Modal className="w-100" isOpen={isOpen} toggle={toggle}>
//       <ModalHeader toggle={toggle}>
//         {selectedUser ? "Edit User" : "Add New User"}
//       </ModalHeader>
//       <Form onSubmit={formik.handleSubmit}>
//         <ModalBody>
//           <Container>
//             <FormGroup>
//               <CustomInput
//                 required
//                 label="Username"
//                 type="text"
//                 name="Username"
//                 id="Username"
//                 handleBlur={formik.handleBlur}
//                 error={formik.errors.Username}
//                 handleChange={formik.handleChange}
//                 value={formik.values.Username}
//                 touched={formik.touched.Username}
//               />
//             </FormGroup>
//             <Row>
//               <Col xs={6}>
//                 <CustomInput
//                   required
//                   label="First Name"
//                   type="text"
//                   name="FirstName"
//                   id="FirstName"
//                   placeholder={"First Name"}
//                   handleBlur={formik.handleBlur}
//                   error={formik.errors.FirstName}
//                   handleChange={formik.handleChange}
//                   value={formik.values.FirstName}
//                   touched={formik.touched.FirstName}
//                 />
//               </Col>
//               <Col xs={6}>
//                 <CustomInput
//                   required
//                   label="Last Name"
//                   type="text"
//                   name="LastName"
//                   id="LastName"
//                   placeholder={"Last Name"}
//                   handleBlur={formik.handleBlur}
//                   error={formik.errors.LastName}
//                   handleChange={formik.handleChange}
//                   value={formik.values.LastName}
//                   touched={formik.touched.LastName}
//                 />
//               </Col>
//             </Row>
//             <FormGroup>
//               <CustomInput
//                 required
//                 label="PhoneNumber"
//                 name="PhoneNumber"
//                 id="PhoneNumber"
//                 error={formik.errors.PhoneNumber}
//                 handleBlur={formik.handleBlur}
//                 handleChange={formik.handleChange}
//                 value={formik.values.PhoneNumber}
//                 touched={formik.touched.PhoneNumber}
//               />
//             </FormGroup>
//             <FormGroup>
//               <CustomInput
//                 required
//                 label="Address"
//                 name="Address"
//                 id="Address"
//                 error={formik.errors.Address}
//                 handleBlur={formik.handleBlur}
//                 handleChange={formik.handleChange}
//                 value={formik.values.Address}
//                 touched={formik.touched.Address}
//               />
//             </FormGroup>
//             <FormGroup>
//               <CustomInput
//                 required
//                 label="Email Address"
//                 name="EmailAddress"
//                 id="EmailAddress"
//                 error={formik.errors.EmailAddress}
//                 handleBlur={formik.handleBlur}
//                 handleChange={formik.handleChange}
//                 value={formik.values.EmailAddress}
//                 touched={formik.touched.EmailAddress}
//               />
//             </FormGroup>
//             <FormGroup>
//               <Row>
//                 <Col xs={6}>
//                   <CustomSelect
//                     required
//                     isMulti
//                     label="Roles"
//                     name="roles"
//                     id="roles"
//                     handleChange={(value) =>
//                       formik.setFieldValue("roles", value)
//                     }
//                     options={roleOptions}
//                     placeholder={"Select Roles"}
//                     value={formik.values.roles}
//                     errors={formik.errors.roles}
//                     touched={formik.touched.roles}
//                     setFieldTouched={formik.setFieldTouched}
//                     setFieldValue={formik.setFieldValue}
//                     handleBlur={formik.handleBlur}
//                   />
//                 </Col>
//               </Row>
//             </FormGroup>
//             <Row>
//               <Col xs={6}>
//                 <FormGroup>
//                   <CustomInput
//                     required
//                     label="Password"
//                     type="password"
//                     name="Password"
//                     id="Password"
//                     placeholder={"Enter password"}
//                     error={formik.errors.Password}
//                     handleBlur={formik.handleBlur}
//                     handleChange={formik.handleChange}
//                     value={formik.values.Password}
//                     touched={formik.touched.Password}
//                   />
//                 </FormGroup>
//               </Col>
//               <Col xs={6}>
//                 <FormGroup>
//                   <CustomInput
//                     required
//                     label="Confirm Password"
//                     handleBlur={formik.handleBlur}
//                     handleChange={formik.handleChange}
//                     id="ConfirmPassword"
//                     type="password"
//                     name="ConfirmPassword"
//                     placeholder="Enter password again"
//                     value={formik.values.ConfirmPassword}
//                     error={formik.errors.ConfirmPassword}
//                     touched={formik.touched.ConfirmPassword}
//                   />
//                 </FormGroup>
//               </Col>
//             </Row>
//             <FormGroup>
//               <div className="text-center">
//                 <div
//                   className="profile-user position-relative d-inline-block mx-auto mb-4"
//                   onClick={handleUserProfileImageClick}
//                 >
//                   <img
//                     src={profileImage}
//                     className="rounded-circle avatar-xl img-thumbnail user-profile-image"
//                     alt="user-profile"
//                   />
//                   <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
//                     <input
//                       id="profile-img-file-input"
//                       type="file"
//                       className="profile-img-file-input"
//                       onChange={handleImageChange}
//                       accept="image/*"
//                       style={{ display: "none" }}
//                     />
//                     <Label
//                       htmlFor="profile-img-file-input"
//                       className="profile-photo-edit avatar-xs"
//                     >
//                       <span className="avatar-title rounded-circle bg-light text-body">
//                         <i className="ri-camera-fill"></i>
//                       </span>
//                     </Label>
//                   </div>
//                 </div>
//               </div>
//             </FormGroup>
//           </Container>
//         </ModalBody>
//         <ModalFooter>
//           <Button color="primary" type="submit">
//             {selectedUser ? "Save" : "Add"}
//           </Button>
//           <Button color="danger" onClick={handleCancel}>
//             Cancel
//           </Button>
//         </ModalFooter>
//       </Form>
//     </Modal>
//   );
// };

// export default AddUserModal;

{
  // import React, { useState, useEffect } from "react";
  // import { useFormik } from "formik";
  // import {
  //   Button,
  //   Modal,
  //   ModalHeader,
  //   ModalBody,
  //   ModalFooter,
  //   FormGroup,
  //   Label,
  //   Container,
  //   Row,
  //   Col,
  //   Form,
  // } from "reactstrap";
  // import CustomInput from "../../Common/CustomInput/CustomInput";
  // import CustomSelect from "../../Common/CustomSelect/CustomSelect";
  // import axios from "axios";
  // import toast from "react-hot-toast";
  // import AuthServices from "../../../services/AuthServices/AuthServices";
  // import CoopUserService from "../../../services/CoopUserService/CoopUserService";
  // import AddUserValidation from "../Validation/AddUserValidation";
  // import { set } from "lodash";
  // const AddUserModal = ({
  //   isOpen,
  //   toggle,
  //   fetchUserType,
  //   selectedUser,
  //   setSelectedUser,
  // }) => {
  //   const [profileImage, setProfileImage] = useState("/imagePlaceholder.png"); // Default image placeholder
  //   const token = JSON.parse(localStorage.getItem("user")).accessToken;
  //   const [roleOptions, setRoleOptions] = useState([]);
  //   const [formattedImage, setFormattedImage] = useState(null);
  //   const formik = useFormik({
  //     enableReinitialize: true,
  //     initialValues: {
  //       Username: selectedUser?.userName || "",
  //       FirstName: selectedUser?.firstName || "",
  //       LastName: selectedUser?.lastName || "",
  //       // Image: selectedUser?.image || profileImage,
  //       Image: selectedUser?.image ?? "",
  //       Address: selectedUser?.Address || "",
  //       EmailAddress: selectedUser?.email || "",
  //       Roles: selectedUser?.roles
  //         ? selectedUser.roles.map((role) => ({
  //             label: role.name,
  //             value: role.id,
  //           }))
  //         : [] || [], // Ensure Roles is an array
  //       PhoneNumber: selectedUser?.phone || "",
  //       Password: selectedUser?.password || "",
  //       ConfirmPassword: selectedUser?.confirmPassword || "",
  //     },
  //     validationSchema: AddUserValidation,
  //     onSubmit: async (values, { resetForm }) => {
  //       // Ensure values.Roles is an array before mapping
  //       const rolesArray = Array.isArray(values.Roles) ? values.Roles : [];
  //       const formData = {
  //         ...values,
  //       };
  //       console.log("formdata", formData);
  //       try {
  //         if (selectedUser) {
  //           await axios.put(
  //             `http://api.dsccou.sebs.asia/api/coopuser/${selectedUser.id}`,
  //             formData,
  //             {
  //               headers: {
  //                 "Content-Type": "multipart/form-data",
  //                 Authorization: `Bearer ${token}`,
  //               },
  //             }
  //           );
  //           console.log("user Id", selectedUser.id);
  //           toast.success("User Updated Successfully");
  //           toggle();
  //           resetForm();
  //           setSelectedUser(null);
  //           fetchUserType();
  //         } else {
  //           await axios.post(
  //             `http://api.dsccou.sebs.asia/api/coopuser/register-coopuser`,
  //             formData,
  //             {
  //               headers: {
  //                 "Content-Type": "multipart/form-data",
  //                 Authorization: `Bearer ${token}`,
  //               },
  //             }
  //           );
  //           toast.success("User Added Successfully");
  //         }
  //         toggle();
  //         resetForm();
  //         setSelectedUser(null);
  //         fetchUserType();
  //       } catch (error) {
  //         toast.error(error.response?.data || "An error occurred");
  //       }
  //     },
  //   });
  //   console.log("formik..values", formik.values);
  //   const fetchRoles = async () => {
  //     try {
  //       const response = await AuthServices.getRoles();
  //       const temp = response.map((item) => {
  //         return {
  //           name: item.name,
  //           label: item.name,
  //         };
  //       });
  //       setRoleOptions(temp);
  //     } catch (error) {
  //       console.log("error", error);
  //     }
  //   };
  //   useEffect(() => {
  //     fetchRoles();
  //   }, []);
  //   const handleCancel = () => {
  //     toggle();
  //     setSelectedUser(null);
  //     setProfileImage("/imagePlaceholder.png");
  //     formik.resetForm();
  //   };
  //   const handleUserProfileImageClick = () => {
  //     document.getElementById("profile-img-file-input").click();
  //   };
  //   useEffect(() => {
  //     (async () => {
  //       if (selectedUser) {
  //         try {
  //           const response = await CoopUserService.getById(selectedUser.id);
  //           if (response.image) {
  //             setProfileImage(`data:image/png;base64,${selectedUser.image}`);
  //             const base64 = selectedUser.image.split(",")[1];
  //             const binaryString = atob(base64);
  //             console.log("Binary IMage", binaryString);
  //             setFormattedImage(binaryString);
  //           }
  //         } catch (error) {
  //           console.log("🚀 ~ async ~ error:", error);
  //         }
  //       }
  //     })();
  //   }, [selectedUser]);
  //   // console.log("Formatted Image", formattedImage);
  //   const handleImageChange = (event) => {
  //     const file = event.target.files[0];
  //     formik.setFieldValue("image", file);
  //     if (file) {
  //       const reader = new FileReader();
  //       reader.onloadend = () => {
  //         setProfileImage(reader.result);
  //       };
  //       reader.readAsDataURL(file);
  //     }
  //   };
  //   // UseEffect to reset form on modal close
  //   useEffect(() => {
  //     if (!isOpen) {
  //       formik.resetForm();
  //       setSelectedUser(null);
  //       setProfileImage("/imagePlaceholder.png");
  //     }
  //   }, [isOpen]);
  //   return (
  //     <Modal className="w-100" isOpen={isOpen} toggle={toggle}>
  //       <ModalHeader toggle={toggle}>
  //         {selectedUser ? "Edit User" : "Add New User"}
  //       </ModalHeader>
  //       <Form onSubmit={formik.handleSubmit}>
  //         <ModalBody>
  //           <Container>
  //             <FormGroup>
  //               <CustomInput
  //                 required
  //                 label="Username"
  //                 type="text"
  //                 name="Username"
  //                 id="Username"
  //                 handleBlur={formik.handleBlur}
  //                 error={formik.errors.Username}
  //                 handleChange={formik.handleChange}
  //                 value={formik.values.Username}
  //                 touched={formik.touched.Username}
  //               />
  //             </FormGroup>
  //             <Row>
  //               <Col xs={6}>
  //                 <CustomInput
  //                   required
  //                   label="First Name"
  //                   type="text"
  //                   name="FirstName"
  //                   id="FirstName"
  //                   placeholder={"First Name"}
  //                   handleBlur={formik.handleBlur}
  //                   error={formik.errors.FirstName}
  //                   handleChange={formik.handleChange}
  //                   value={formik.values.FirstName}
  //                   touched={formik.touched.FirstName}
  //                 />
  //               </Col>
  //               <Col xs={6}>
  //                 <CustomInput
  //                   required
  //                   label="Last Name"
  //                   type="text"
  //                   name="LastName"
  //                   id="LastName"
  //                   placeholder={"Last Name"}
  //                   handleBlur={formik.handleBlur}
  //                   error={formik.errors.LastName}
  //                   handleChange={formik.handleChange}
  //                   value={formik.values.LastName}
  //                   touched={formik.touched.LastName}
  //                 />
  //               </Col>
  //             </Row>
  //             <FormGroup>
  //               <CustomInput
  //                 required
  //                 label="PhoneNumber"
  //                 name="PhoneNumber"
  //                 id="PhoneNumber"
  //                 error={formik.errors.PhoneNumber}
  //                 handleBlur={formik.handleBlur}
  //                 handleChange={formik.handleChange}
  //                 value={formik.values.PhoneNumber}
  //                 touched={formik.touched.PhoneNumber}
  //               />
  //             </FormGroup>
  //             <FormGroup>
  //               <CustomInput
  //                 required
  //                 label="Email Address"
  //                 name="EmailAddress"
  //                 id="EmailAddress"
  //                 error={formik.errors.EmailAddress}
  //                 handleBlur={formik.handleBlur}
  //                 handleChange={formik.handleChange}
  //                 value={formik.values.EmailAddress}
  //                 touched={formik.touched.EmailAddress}
  //               />
  //             </FormGroup>
  //             <FormGroup>
  //               <Row>
  //                 <Col xs={6}>
  //                   <CustomSelect
  //                     required
  //                     isMulti
  //                     label="Roles"
  //                     name="Roles"
  //                     id="Roles"
  //                     options={roleOptions}
  //                     placeholder={"Select Roles"}
  //                     value={formik.values.Roles}
  //                     errors={formik.errors.Roles}
  //                     touched={formik.touched.Roles}
  //                     setFieldTouched={formik.setFieldTouched}
  //                     setFieldValue={formik.setFieldValue}
  //                   />
  //                   {/* {formik.touched.Roles && formik.errors.Roles && (
  //                     <small className="text-danger">{formik.errors.Roles}</small>
  //                   )} */}
  //                 </Col>
  //               </Row>
  //             </FormGroup>
  //             <Row>
  //               <Col xs={6}>
  //                 <FormGroup>
  //                   <CustomInput
  //                     required
  //                     label="Password"
  //                     type="password"
  //                     name="Password"
  //                     id="Password"
  //                     placeholder={"Enter password"}
  //                     error={formik.errors.Password}
  //                     handleBlur={formik.handleBlur}
  //                     handleChange={formik.handleChange}
  //                     value={formik.values.Password}
  //                     touched={formik.touched.Password}
  //                   />
  //                 </FormGroup>
  //               </Col>
  //               <Col xs={6}>
  //                 <FormGroup>
  //                   <CustomInput
  //                     required
  //                     label="Confirm Password"
  //                     handleBlur={formik.handleBlur}
  //                     handleChange={formik.handleChange}
  //                     id="ConfirmPassword"
  //                     type="password"
  //                     name="ConfirmPassword"
  //                     placeholder="Enter password again"
  //                     value={formik.values.ConfirmPassword}
  //                     error={formik.errors.ConfirmPassword}
  //                     touched={formik.touched.ConfirmPassword}
  //                   />
  //                 </FormGroup>
  //               </Col>
  //             </Row>
  //             <FormGroup>
  //               <div className="text-center">
  //                 <div
  //                   className="profile-user position-relative d-inline-block mx-auto mb-4"
  //                   onClick={handleUserProfileImageClick}
  //                 >
  //                   <img
  //                     src={profileImage}
  //                     className="rounded-circle avatar-xl img-thumbnail user-profile-image"
  //                     alt="user-profile"
  //                   />
  //                   <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
  //                     <input
  //                       id="profile-img-file-input"
  //                       type="file"
  //                       className="profile-img-file-input"
  //                       onChange={handleImageChange}
  //                       accept="image/*"
  //                       style={{ display: "none" }}
  //                     />
  //                     <Label
  //                       htmlFor="profile-img-file-input"
  //                       className="profile-photo-edit avatar-xs"
  //                     >
  //                       <span className="avatar-title rounded-circle bg-light text-body">
  //                         <i
  //                           className="ri-camera-fill"
  //                           // onClick={handleUserProfileImageClick}
  //                         ></i>
  //                       </span>
  //                     </Label>
  //                   </div>
  //                 </div>
  //               </div>
  //             </FormGroup>
  //           </Container>
  //         </ModalBody>
  //         <ModalFooter>
  //           <Button color="primary" type="submit">
  //             {selectedUser ? "Save" : "Add"}
  //           </Button>
  //           <Button color="danger" onClick={handleCancel}>
  //             Cancel
  //           </Button>
  //         </ModalFooter>
  //       </Form>
  //     </Modal>
  //   );
  // };
  // export default AddUserModal;
}

{
  // import React, { useState, useEffect } from "react";
  // import { useFormik } from "formik";
  // import {
  //   Button,
  //   Modal,
  //   ModalHeader,
  //   ModalBody,
  //   ModalFooter,
  //   FormGroup,
  //   Label,
  //   Container,
  //   Row,
  //   Col,
  //   Form,
  // } from "reactstrap";
  // import CustomInput from "../../Common/CustomInput/CustomInput";
  // import CustomSelect from "../../Common/CustomSelect/CustomSelect";
  // import axios from "axios";
  // import toast from "react-hot-toast";
  // import AuthServices from "../../../services/AuthServices/AuthServices";
  // import CoopUserService from "../../../services/CoopUserService/CoopUserService";
  // import AddUserValidation from "../Validation/AddUserValidation";
  // import { set } from "lodash";
  // const AddUserModal = ({
  //   isOpen,
  //   toggle,
  //   fetchUserType,
  //   selectedUser,
  //   setSelectedUser,
  // }) => {
  //   const [profileImage, setProfileImage] = useState("/imagePlaceholder.png"); // Default image placeholder
  //   const token = JSON.parse(localStorage.getItem("user")).accessToken;
  //   const [roleOptions, setRoleOptions] = useState([]);
  //   const [formattedImage, setFormattedImage] = useState(null);
  //   const formik = useFormik({
  //     enableReinitialize: true,
  //     initialValues: {
  //       Username: selectedUser?.userName || "",
  //       FirstName: selectedUser?.firstName || "",
  //       LastName: selectedUser?.lastName || "",
  //       // Image: selectedUser?.image || profileImage,
  //       Image: selectedUser?.image ?? "",
  //       Address: selectedUser?.Address || "",
  //       EmailAddress: selectedUser?.email || "",
  //       Roles: selectedUser?.roles
  //         ? selectedUser.roles.map((role) => ({
  //             label: role.name,
  //             value: role.id,
  //           }))
  //         : [] || [], // Ensure Roles is an array
  //       PhoneNumber: selectedUser?.phone || "",
  //       Password: selectedUser?.password || "",
  //       ConfirmPassword: selectedUser?.confirmPassword || "",
  //     },
  //     validationSchema: AddUserValidation,
  //     onSubmit: async (values, { resetForm }) => {
  //       // Ensure values.Roles is an array before mapping
  //       const rolesArray = Array.isArray(values.Roles) ? values.Roles : [];
  //       const formData = {
  //         ...values,
  //       };
  //       console.log("formdata", formData);
  //       try {
  //         if (selectedUser) {
  //           await axios.put(
  //             `http://api.dsccou.sebs.asia/api/coopuser/${selectedUser.id}`,
  //             formData,
  //             {
  //               headers: {
  //                 "Content-Type": "multipart/form-data",
  //                 Authorization: `Bearer ${token}`,
  //               },
  //             }
  //           );
  //           console.log("user Id", selectedUser.id);
  //           toast.success("User Updated Successfully");
  //           toggle();
  //           resetForm();
  //           setSelectedUser(null);
  //           fetchUserType();
  //         } else {
  //           await axios.post(
  //             `http://api.dsccou.sebs.asia/api/coopuser/register-coopuser`,
  //             formData,
  //             {
  //               headers: {
  //                 "Content-Type": "multipart/form-data",
  //                 Authorization: `Bearer ${token}`,
  //               },
  //             }
  //           );
  //           toast.success("User Added Successfully");
  //         }
  //         toggle();
  //         resetForm();
  //         setSelectedUser(null);
  //         fetchUserType();
  //       } catch (error) {
  //         toast.error(error.response?.data || "An error occurred");
  //       }
  //     },
  //   });
  //   console.log("formik..values", formik.values);
  //   const fetchRoles = async () => {
  //     try {
  //       const response = await AuthServices.getRoles();
  //       const temp = response.map((item) => {
  //         return {
  //           name: item.name,
  //           label: item.name,
  //         };
  //       });
  //       setRoleOptions(temp);
  //     } catch (error) {
  //       console.log("error", error);
  //     }
  //   };
  //   useEffect(() => {
  //     fetchRoles();
  //   }, []);
  //   const handleCancel = () => {
  //     toggle();
  //     setSelectedUser(null);
  //     setProfileImage("/imagePlaceholder.png");
  //     formik.resetForm();
  //   };
  //   const handleUserProfileImageClick = () => {
  //     document.getElementById("profile-img-file-input").click();
  //   };
  //   useEffect(() => {
  //     (async () => {
  //       if (selectedUser) {
  //         try {
  //           const response = await CoopUserService.getById(selectedUser.id);
  //           if (response.image) {
  //             setProfileImage(`data:image/png;base64,${selectedUser.image}`);
  //             const base64 = selectedUser.image.split(",")[1];
  //             const binaryString = atob(base64);
  //             console.log("Binary IMage", binaryString);
  //             setFormattedImage(binaryString);
  //           }
  //         } catch (error) {
  //           console.log("🚀 ~ async ~ error:", error);
  //         }
  //       }
  //     })();
  //   }, [selectedUser]);
  //   // console.log("Formatted Image", formattedImage);
  //   const handleImageChange = (event) => {
  //     const file = event.target.files[0];
  //     formik.setFieldValue("image", file);
  //     if (file) {
  //       const reader = new FileReader();
  //       reader.onloadend = () => {
  //         setProfileImage(reader.result);
  //       };
  //       reader.readAsDataURL(file);
  //     }
  //   };
  //   // UseEffect to reset form on modal close
  //   useEffect(() => {
  //     if (!isOpen) {
  //       formik.resetForm();
  //       setSelectedUser(null);
  //       setProfileImage("/imagePlaceholder.png");
  //     }
  //   }, [isOpen]);
  //   return (
  //     <Modal className="w-100" isOpen={isOpen} toggle={toggle}>
  //       <ModalHeader toggle={toggle}>
  //         {selectedUser ? "Edit User" : "Add New User"}
  //       </ModalHeader>
  //       <Form onSubmit={formik.handleSubmit}>
  //         <ModalBody>
  //           <Container>
  //             <FormGroup>
  //               <CustomInput
  //                 required
  //                 label="Username"
  //                 type="text"
  //                 name="Username"
  //                 id="Username"
  //                 handleBlur={formik.handleBlur}
  //                 error={formik.errors.Username}
  //                 handleChange={formik.handleChange}
  //                 value={formik.values.Username}
  //                 touched={formik.touched.Username}
  //               />
  //             </FormGroup>
  //             <Row>
  //               <Col xs={6}>
  //                 <CustomInput
  //                   required
  //                   label="First Name"
  //                   type="text"
  //                   name="FirstName"
  //                   id="FirstName"
  //                   placeholder={"First Name"}
  //                   handleBlur={formik.handleBlur}
  //                   error={formik.errors.FirstName}
  //                   handleChange={formik.handleChange}
  //                   value={formik.values.FirstName}
  //                   touched={formik.touched.FirstName}
  //                 />
  //               </Col>
  //               <Col xs={6}>
  //                 <CustomInput
  //                   required
  //                   label="Last Name"
  //                   type="text"
  //                   name="LastName"
  //                   id="LastName"
  //                   placeholder={"Last Name"}
  //                   handleBlur={formik.handleBlur}
  //                   error={formik.errors.LastName}
  //                   handleChange={formik.handleChange}
  //                   value={formik.values.LastName}
  //                   touched={formik.touched.LastName}
  //                 />
  //               </Col>
  //             </Row>
  //             <FormGroup>
  //               <CustomInput
  //                 required
  //                 label="PhoneNumber"
  //                 name="PhoneNumber"
  //                 id="PhoneNumber"
  //                 error={formik.errors.PhoneNumber}
  //                 handleBlur={formik.handleBlur}
  //                 handleChange={formik.handleChange}
  //                 value={formik.values.PhoneNumber}
  //                 touched={formik.touched.PhoneNumber}
  //               />
  //             </FormGroup>
  //             <FormGroup>
  //               <CustomInput
  //                 required
  //                 label="Email Address"
  //                 name="EmailAddress"
  //                 id="EmailAddress"
  //                 error={formik.errors.EmailAddress}
  //                 handleBlur={formik.handleBlur}
  //                 handleChange={formik.handleChange}
  //                 value={formik.values.EmailAddress}
  //                 touched={formik.touched.EmailAddress}
  //               />
  //             </FormGroup>
  //             <FormGroup>
  //               <Row>
  //                 <Col xs={6}>
  //                   <CustomSelect
  //                     required
  //                     isMulti
  //                     label="Roles"
  //                     name="Roles"
  //                     id="Roles"
  //                     options={roleOptions}
  //                     placeholder={"Select Roles"}
  //                     value={formik.values.Roles}
  //                     errors={formik.errors.Roles}
  //                     touched={formik.touched.Roles}
  //                     setFieldTouched={formik.setFieldTouched}
  //                     setFieldValue={formik.setFieldValue}
  //                   />
  //                   {/* {formik.touched.Roles && formik.errors.Roles && (
  //                     <small className="text-danger">{formik.errors.Roles}</small>
  //                   )} */}
  //                 </Col>
  //               </Row>
  //             </FormGroup>
  //             <Row>
  //               <Col xs={6}>
  //                 <FormGroup>
  //                   <CustomInput
  //                     required
  //                     label="Password"
  //                     type="password"
  //                     name="Password"
  //                     id="Password"
  //                     placeholder={"Enter password"}
  //                     error={formik.errors.Password}
  //                     handleBlur={formik.handleBlur}
  //                     handleChange={formik.handleChange}
  //                     value={formik.values.Password}
  //                     touched={formik.touched.Password}
  //                   />
  //                 </FormGroup>
  //               </Col>
  //               <Col xs={6}>
  //                 <FormGroup>
  //                   <CustomInput
  //                     required
  //                     label="Confirm Password"
  //                     handleBlur={formik.handleBlur}
  //                     handleChange={formik.handleChange}
  //                     id="ConfirmPassword"
  //                     type="password"
  //                     name="ConfirmPassword"
  //                     placeholder="Enter password again"
  //                     value={formik.values.ConfirmPassword}
  //                     error={formik.errors.ConfirmPassword}
  //                     touched={formik.touched.ConfirmPassword}
  //                   />
  //                 </FormGroup>
  //               </Col>
  //             </Row>
  //             <FormGroup>
  //               <div className="text-center">
  //                 <div
  //                   className="profile-user position-relative d-inline-block mx-auto mb-4"
  //                   onClick={handleUserProfileImageClick}
  //                 >
  //                   <img
  //                     src={profileImage}
  //                     className="rounded-circle avatar-xl img-thumbnail user-profile-image"
  //                     alt="user-profile"
  //                   />
  //                   <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
  //                     <input
  //                       id="profile-img-file-input"
  //                       type="file"
  //                       className="profile-img-file-input"
  //                       onChange={handleImageChange}
  //                       accept="image/*"
  //                       style={{ display: "none" }}
  //                     />
  //                     <Label
  //                       htmlFor="profile-img-file-input"
  //                       className="profile-photo-edit avatar-xs"
  //                     >
  //                       <span className="avatar-title rounded-circle bg-light text-body">
  //                         <i
  //                           className="ri-camera-fill"
  //                           // onClick={handleUserProfileImageClick}
  //                         ></i>
  //                       </span>
  //                     </Label>
  //                   </div>
  //                 </div>
  //               </div>
  //             </FormGroup>
  //           </Container>
  //         </ModalBody>
  //         <ModalFooter>
  //           <Button color="primary" type="submit">
  //             {selectedUser ? "Save" : "Add"}
  //           </Button>
  //           <Button color="danger" onClick={handleCancel}>
  //             Cancel
  //           </Button>
  //         </ModalFooter>
  //       </Form>
  //     </Modal>
  //   );
  // };
  // export default AddUserModal;
}
